import 'deepmerge';

function isHexColorCode(code) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(code);
}

var ARSimpleForm = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{class:[
    'ar-simple-form',
    _vm.opened && 'opened',
    _vm.disabled && 'disabled' ],style:({
    padding: _vm.opened ? '11px 20px' : '0 20px',
  }),attrs:{"ar-widget-id":"ar-simple-form","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-simple-form"},on:{"click":_vm.handleFormClick,"submit":function($event){$event.preventDefault();return _vm.handleFormSubmit($event)}}},[_c('div',{staticClass:"ar-simple-form-left-section"},[(_vm.iconName)?_c('ar-icon',{attrs:{"name":_vm.iconName,"width":"16px","color":_vm.$arStyle.color.skyBlueGrey700}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"ar-simple-form-right-section"},[_c('div',{style:({
        height: _vm.opened ? 0 : null,
        overflow: 'hidden',
      })},[_c('div',{style:({
          minHeight: '40px',
        })},[(_vm.parsedData)?_c('div',{style:({
            padding: '10px 0 11px',
          })},[_c('ar-text',{attrs:{"size":"xs","text":_vm.parsedData,"multiple-lines":"","allow-html":"","line-height":"20px"}})],1):_c('ar-link-button',{style:({
            marginTop: '13px',
          }),attrs:{"text":("+ " + _vm.placeholder),"text-props":{
            weight: 'bold',
          },"has-underline":false,"color":_vm.color},on:{"click":_vm.handleFormClick}})],1)]),_vm._v(" "),_c('div',{style:({
        height: _vm.opened ? null : 0,
        overflow: _vm.opened ? null : 'hidden',
      })},[_c('div',{style:({
          padding: '2px',
          minHeight: '40px',
        })},[_vm._t("fields"),_vm._v(" "),_c('div',{staticClass:"u-margin-top-2 u-display-flex u-align-items-center"},[_c('ar-simple-button',{style:({
              width: '90px',
              height: '40px',
            }),attrs:{"text":"Save","type":_vm.color,"loading":_vm.loading}}),_vm._v(" "),(!_vm.loading)?_c('ar-link-button',{staticClass:"u-margin-left-3",attrs:{"show-arrow":false,"show-underline":"","color":_vm.color,"text":"Cancel"},on:{"click":_vm.handleCancelClick}}):_vm._e()],1)],2)])])])},
staticRenderFns: [],
  name: 'ARSimpleForm',
  props: {
    arWidgetMeta: String,
    color: {
      type: String,
      default: 'purple',
      validator: (value) => {
        return ['purple'].indexOf(value) > -1 || isHexColorCode(value);
      },
    },
    iconName: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Add data',
    },
    opened: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    parsedData: {
      type: String,
      default: null,
    },
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `placeholder=${this.placeholder};`,
        `text=${this.parsedData};`,
      ].join('');
    },
  },
  methods: {
    handleFormClick() {
      if (this.disabled || this.opened) {
        return;
      }
      this.$emit('open');
    },
    handleCancelClick() {
      this.$emit('cancel');
    },
    handleFormSubmit() {
      this.$emit('submit');
    },
  },
};

export default ARSimpleForm;
